export default function (initialDataInteractor) {
  return initialDataInteractor.data.questionnaires;
}